<template>
  <BaseCustomizeMetal componentCode="AH" useNotReverse />
</template>

<script>
import BaseCustomizeMetal from "@/components/customizeMetal/traditionalMetal/BaseCustomizeMetal/index.vue";
export default {
  name: "CustomizeMetalAH",
  components: {
    BaseCustomizeMetal,
  },
};
</script>

<style scoped lang="scss">
::v-deep {
  .metal-text {
    top: 84px;
    left: 111px;
    @include betweenTableTablePro {
      top: 51px;
      left: 61px;
    }
    @include table {
      top: 32px;
      left: 36px;
    }
    @include phone {
      top: 23px;
      left: 21px;
    }
  }
  .templeName {
    height: 33px;
    width: 227px;
    margin: 0 auto;
    justify-content: center;
    .textContainer {
      width: 235px;
    }
  }
  .godName {
    width: 279px;
    height: 68px;
    margin: 14px auto 10px;
    .textContainer {
      width: 279px;
    }
  }
  .gift {
    width: 177px;
    height: 33px;
    justify-content: center;
    position: absolute;
    top: 125px;
    left: 76px;
    .textContainer {
      width: 171px;
    }
  }
  .respect {
    position: absolute;
    top: 128px;
    left: 26px;
  }
}
</style>
